export type ShipmentMode = 'reserve' | 'pickup' | 'transfer' | 'old_invoice'

export interface ModeTheme {
  accent: string
  accentHover: string
  border: string
  bg: string
  text: string
  badge: string
  primaryBtn: string
}

export const MODE_THEME: Record<ShipmentMode, ModeTheme> = {
  reserve: {
    accent: 'text-amber-600 dark:text-amber-400',
    accentHover: 'hover:text-amber-700 dark:hover:text-amber-300',
    border: 'border-amber-500',
    bg: 'bg-amber-50 dark:bg-amber-900/20',
    text: 'text-amber-700 dark:text-amber-300',
    badge: 'bg-amber-100 dark:bg-amber-900/30 text-amber-700 dark:text-amber-300',
    primaryBtn: 'bg-amber-600 hover:bg-amber-700'
  },
  pickup: {
    accent: 'text-green-600 dark:text-green-400',
    accentHover: 'hover:text-green-700 dark:hover:text-green-300',
    border: 'border-green-500',
    bg: 'bg-green-50 dark:bg-green-900/20',
    text: 'text-green-700 dark:text-green-300',
    badge: 'bg-green-100 dark:bg-green-900/30 text-green-700 dark:text-green-300',
    primaryBtn: 'bg-green-600 hover:bg-green-700'
  },
  transfer: {
    accent: 'text-teal-600 dark:text-teal-400',
    accentHover: 'hover:text-teal-700 dark:hover:text-teal-300',
    border: 'border-teal-500',
    bg: 'bg-teal-50 dark:bg-teal-900/20',
    text: 'text-teal-700 dark:text-teal-300',
    badge: 'bg-teal-100 dark:bg-teal-900/30 text-teal-700 dark:text-teal-300',
    primaryBtn: 'bg-teal-600 hover:bg-teal-700'
  },
  old_invoice: {
    accent: 'text-indigo-600 dark:text-indigo-400',
    accentHover: 'hover:text-indigo-700 dark:hover:text-indigo-300',
    border: 'border-indigo-500',
    bg: 'bg-indigo-50 dark:bg-indigo-900/20',
    text: 'text-indigo-700 dark:text-indigo-300',
    badge: 'bg-indigo-100 dark:bg-indigo-900/30 text-indigo-700 dark:text-indigo-300',
    primaryBtn: 'bg-indigo-600 hover:bg-indigo-700'
  }
}
